import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Linkedin, Briefcase, Shield } from 'lucide-react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-grid">
          <div className="footer-section">
            <div className="footer-logo">
              <Shield size={24} />
              <span>Vianney Soulard</span>
            </div>
            <p className="footer-description">
              Pentester freelance spécialisé en sécurité des applications Web et API.
              Basé à Angers, interventions à distance.
            </p>
          </div>

          <div className="footer-section">
            <h3 className="footer-title">Navigation</h3>
            <nav className="footer-nav">
              <Link to="/" className="footer-link">Accueil</Link>
              <Link to="/services" className="footer-link">Services</Link>
              <Link to="/a-propos" className="footer-link">À propos</Link>
              <Link to="/experiences" className="footer-link">Expériences</Link>
              <Link to="/contact" className="footer-link">Contact</Link>
            </nav>
          </div>

          <div className="footer-section">
            <h3 className="footer-title">Contact</h3>
            <div className="footer-contact">
              <a href="mailto:vianney-s@hotmail.fr" className="footer-contact-item">
                <Mail size={18} />
                <span>vianney-s@hotmail.fr</span>
              </a>
              <a
                href="https://www.linkedin.com/in/vianneysoulard"
                target="_blank"
                rel="noopener noreferrer"
                className="footer-contact-item"
              >
                <Linkedin size={18} />
                <span>LinkedIn</span>
              </a>
              <a
                href="https://www.malt.fr/profile/vianneysoulard1"
                target="_blank"
                rel="noopener noreferrer"
                className="footer-contact-item"
              >
                <Briefcase size={18} />
                <span>Malt</span>
              </a>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} Vianney Soulard. Tous droits réservés.</p>
          <div className="footer-legal">
            <Link to="/mentions-legales" className="footer-link">Mentions légales</Link>
            <Link to="/confidentialite" className="footer-link">Confidentialité</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;